import { render, staticRenderFns } from "./TheTemplate.vue?vue&type=template&id=2ed920df&scoped=true&lang=pug"
import script from "./TheTemplate.vue?vue&type=script&lang=ts"
export * from "./TheTemplate.vue?vue&type=script&lang=ts"
import style0 from "./TheTemplate.vue?vue&type=style&index=0&id=2ed920df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed920df",
  null
  
)

export default component.exports